import lodash from 'lodash';

export function hasSameValueCaseInsensitive(value1, value2) {
    if (lodash.isString(value1) && lodash.isString(value2)) {
        return lodash.eq(value1.toLowerCase(), value2.toLowerCase());
    }
    return lodash.eq(value1, value2);
}
